// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // BASE_URL: 'http://localhost:4200' //local
  BASE_URL: '', // prod,
  // BACKEND_URL :'http://192.168.42.170:8951'
 //BACKEND_URL: 'http://localhost:8952',
   //TBWALEGACY_URL: 'http://localhost:4300'
 BACKEND_URL: 'https://gestionbe.traficotbwaperu.com',
  TBWALEGACY_URL: 'https://time.traficotbwaperu.com'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts